import React from 'react';
import { Vehicle } from '../../types';
import { formatKoreanDate, formatToKoreanUnit } from '../../utils/formatters';

interface VehicleCardProps {
  vehicle: Vehicle;
  isNew?: boolean;
}

function VehicleCard({ vehicle, isNew = false }: VehicleCardProps) {
  return (
    <div 
      className={`bg-slate-800 rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-primary-500/30 hover:-translate-y-1 ${isNew ? 'animate-fadeIn' : ''}`}
    >
      <div className="relative aspect-square">
        <img 
          src={vehicle.image} 
          alt={vehicle.vehicleName} 
          className="w-full h-full object-cover"
          loading="lazy"
          width="1024"
          height="1024"
        />
        
        {isNew && (
          <div className="absolute top-3 right-3 bg-blue-500 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-lg">
            신규
          </div>
        )}
        
        {vehicle.grade && (
          <div className={`absolute top-3 left-3 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-lg ${getGradeColor(vehicle.grade)}`}>
            {vehicle.grade}
          </div>
        )}
      </div>
      
      <div className="p-5">
        <div className="flex justify-between mb-1">
          <h3 className="text-xl font-semibold text-white">{vehicle.vehicleName}</h3>
          {vehicle.year && <span className="text-gray-400 text-sm">{vehicle.year}년식</span>}
        </div>
        
        <div className="text-primary-400 font-bold mb-2">
          {formatToKoreanUnit(vehicle.price)}
        </div>
        
        {(vehicle.fuel || vehicle.color) && (
          <div className="text-gray-400 text-sm mb-2">
            {vehicle.fuel && vehicle.color ? `${vehicle.fuel} · ${vehicle.color}` : vehicle.fuel || vehicle.color}
          </div>
        )}
        
        <div className="flex justify-between items-center">
          <div className="text-gray-500 text-xs">
            {formatKoreanDate(vehicle.registeredAt)} 등록
          </div>
          {/* <div className="text-gray-400 text-xs">
            {vehicle.tokenName}
          </div> */}
        </div>
      </div>
    </div>
  );
}

// 차량 등급에 따른 배경색 지정
function getGradeColor(grade: string): string {
  switch(grade.toLowerCase()) {
    case '스톤':
      return 'bg-gray-600';
    case '브론즈':
      return 'bg-yellow-700';
    case '실버':
      return 'bg-gray-400';
    case '골드':
      return 'bg-yellow-500';
    case '플래티넘':
      return 'bg-blue-300';
    case '사파이어':
      return 'bg-blue-600';
    case '다이아몬드':
      return 'bg-purple-500';
    default:
      return 'bg-blue-500';
  }
}

export default VehicleCard; 